module.exports = __webpack_public_path__ + "static/media/dropdownUpArrow.257de33b.svg";